export default "__VITE_ASSET__D8sd87NS__"